import { BaseServiceSetup, communicationService, context, utils } from '@wikia/ad-engine';
import { AD_ENGINE_GPT_READY } from '../../../communication/events/events-ad-engine';

const GPT_TIMEOUT_MS = 10 * 1000;
const GPT_LIBRARY_URL = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

export class GptSetup extends BaseServiceSetup {
	private loadPromise: Promise<void> | undefined;

	options = { timeout: GPT_TIMEOUT_MS };

	call(): Promise<void> {
		if (window.fandomPerf?.preloadGPT) {
			return window.fandomPerf?.preloadGPT.then(() => {
				utils.logger('gpt-provider', 'ready');
				communicationService.emit(AD_ENGINE_GPT_READY, {
					time: utils.getTimeDelta(),
				});
			});
		}

		if (!this.loadPromise) {
			utils.logger('gpt-provider', 'loading GPT...');
			const scriptUrl = `${GPT_LIBRARY_URL}?network-code=${context.get('custom.dfpId')}`;
			this.loadPromise = utils.scriptLoader.loadScript(scriptUrl).then(() => {
				utils.logger('gpt-provider', 'ready');
				communicationService.emit(AD_ENGINE_GPT_READY, {
					time: utils.getTimeDelta(),
				});
			});
		}
		return this.loadPromise;
	}
}
